import React, { useState, useEffect } from 'react';
import styles from './ResetPassword.module.css';
import { requestPasswordReset } from '../../../firebase/authService';
import { mapAuthError } from '../../../utils/authErrors';
import { validateEmailFormat, normalizeEmail } from '../../../utils/validation';
import { hasFirebaseConfig } from '../../../firebase/firebaseConfig';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // success | error | null
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [visible, setVisible] = useState(false);
  const ready = hasFirebaseConfig();

  const onSubmit = (e) => {
    e.preventDefault();
    setStatus(null);
    setMessage('');
    const normalized = normalizeEmail(email);
    if (!normalized) {
      setStatus('error');
      setMessage('メールアドレスを入力してください');
      return;
    }
    if (!validateEmailFormat(normalized)) {
      setStatus('error');
      setMessage('メールアドレスの形式が不正です');
      return;
    }
    if (!ready) {
      setStatus('error');
      setMessage('Firebase 設定が未ロードです');
      return;
    }
    if (cooldown > 0) return;
    setLoading(true);
    (async () => {
      try {
  await requestPasswordReset(normalized);
        setStatus('success');
        setMessage('パスワードリセット用リンクを送信しました');
        setCooldown(30);
      } catch (err) {
        console.error(err);
  setStatus('error');
  setMessage(mapAuthError(err));
      } finally {
        setLoading(false);
      }
    })();
  };

  // cooldown count down
  useEffect(() => {
    if (cooldown > 0) {
      const t = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [cooldown]);

  useEffect(() => {
    if (status) {
      setVisible(true);
      const t = setTimeout(() => setVisible(false), 6000);
      return () => clearTimeout(t);
    }
  }, [status, message]);

  if (!ready) {
    return (
      <div className={styles.container}>
        <h1 className={styles.title}>パスワードリセット</h1>
        <p className={styles.text}>Firebase 設定が読み込まれていません。runtime-firebase-config.js もしくは .env.local を確認してください。</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>パスワードリセット</h1>
      <form className={styles.form} onSubmit={onSubmit} noValidate>
        <label className={styles.label}>
          メールアドレス
          <input
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
        </label>
        {status && visible && (
          <div className={status === 'success' ? styles.success : styles.error}>{message}</div>
        )}
        {cooldown > 0 && <div className={styles.error}>再送は {cooldown} 秒後に可能</div>}
        <button type="submit" className={styles.submit} disabled={loading || cooldown>0}>
          {loading ? '送信中...' : (cooldown>0 ? '待機中...' : 'リセットリンクを送信')}
        </button>
        <div className={styles.links}>
          <a href="/signin">サインインへ戻る</a>
        </div>
      </form>
    </div>
  );
}
